import { isArr, isStr, isObj } from "./type";
export function each(val, iterator) {
    if (isArr(val) || isStr(val)) {
        for (var i = 0; i < val.length; i++) {
            if (iterator(val[i], i) === false) {
                return;
            }
        }
    }
    else if (isObj(val)) {
        var keys = Object.keys(val);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // @ts-expect-error 111
            if (iterator(val[key], key) === false) {
                return;
            }
        }
    }
}
